import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pagination-box" }

import {reactive,computed} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    currentPage: {},
    pageSize: { default: 10 },
    total: {}
  },
  emits: ["changePage", "changeSize", "update:pageSize", "update:currentPage"],
  setup(__props: any, { emit: __emit }) {

const props = __props
let paginationData = reactive({
  currentPage: computed({
    get: () => props.currentPage,
    set: (val: number) => {
      emits('update:currentPage', val)
    }
  }),
  pageSize: computed({
    get: () => props.pageSize,
    set: (val: number) => {
      emits('update:pageSize', val)
    }
  }),
})

// 每页条数
const changeSize = (size: number) => {
  paginationData.currentPage = 1;
  paginationData.pageSize = size;
  emits('changeSize', size)
}

// 翻页
const changePage = (page: number) => {
  paginationData.currentPage = page;
  emits('changePage', page)
}

const emits = __emit


return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_pagination, {
      "current-page": _unref(paginationData).currentPage,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_unref(paginationData).currentPage) = $event)),
      "page-size": _unref(paginationData).pageSize,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_unref(paginationData).pageSize) = $event)),
      "page-sizes": [10, 20,50, 100],
      background: false,
      "hide-on-single-page": false,
      layout: "total, sizes, prev, pager, next, jumper",
      total: props.total,
      onSizeChange: changeSize,
      onCurrentChange: changePage
    }, null, 8, ["current-page", "page-size", "total"])
  ]))
}
}

})